/**
 * Product images and offer details.
 *
 * HERO_IMAGE: while it's empty, the hero and the pricing card draw the six
 * volumes in code, in the same look as the Volume 1 cover.
 */
export const HERO_IMAGE = 'https://cdn.magicpatterns.com/uploads/u9nZTqpCwJxW4Lnigd2GRf/DPS-28_mockup-6-tomos_B.png'

export const HERO_IMAGE_ALT =
  'The six No-Queue Cricket volumes: Set Up the Squad, Bat Without the Queue, Bowl Line and Length, Field Like a Team, Play the Match Before Match Day and Finish the Season Strong'

/** Where the pricing-card button sends the coach. */
export const CHECKOUT_URL = 'https://no-queue-cricket.impultienda.ar/checkout'

/** Offer, in USD. */
export const PRICE = 27
export const TOTAL_VALUE = 97
export const PRICE_AFTER_LAUNCH = 47

/** Support inbox shown in the footer. */
export const SUPPORT_EMAIL = 'help@iclcollective.com'
